import * as Yup from 'yup';
import type { IncidentReportYesNoOther } from 'components/CriticalIncident/interfaces';

type StringSchemaCtx = Yup.StringSchema<string | undefined, Yup.AnyObject, undefined, "">;

export const yesNoOther = Yup.string().oneOf(['Y', 'N', 'O', ''] as IncidentReportYesNoOther[]);

// resetOtherwise=false leaves the field's existing schema untouched when the condition is false, instead of calling .notRequired() (which also adds .nullable())
export const requiredWhenIs = (matchValue: unknown, resetOtherwise = true) => ({
    is: matchValue,
    then: (schema: StringSchemaCtx) => schema.required('error_required_field'),
    ...(resetOtherwise && { otherwise: (schema: StringSchemaCtx) => schema.notRequired() }),
});

export const requiredWhenValueIn = (allowedValues: string[], resetOtherwise = true) => ({
    is: (value: string) => allowedValues.includes(value),
    then: (schema: StringSchemaCtx) => schema.required('error_required_field'),
    ...(resetOtherwise && { otherwise: (schema: StringSchemaCtx) => schema.notRequired() }),
});

export const minOneWhenTrue = () => ({
    is: true,
    then: (schema: any) => schema.min(1, 'error_required_field'),
});
